<template>
  <div class="drill-management drillman flex-1">
    <DrillsTable />
    <SnackbarLinkGuide
      localKey="trainer_drills"
      :link="links_url_links.trainer_drills.url"
      :text="$t('messages.get_most_of_drills')"
    />
  </div>
</template>

<script>
import SnackbarLinkGuide from '@/components/Messages/SnackbarLinkGuide'
import DrillsTable from '@/components/DataTables/v2/tables/DrillsTable/DrillsTable'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'DrillManagementV2',
  components: {
    DrillsTable,
    SnackbarLinkGuide,
  },
  mixins: [links_mix],
}
</script>

<style lang="scss" scoped>
.drillman {
  display: flex;
  z-index: 1;
  min-height: 0;
  min-width: 0;
  flex-direction: column;
}
</style>
